/* Mondsee Jewelry — Custom JS v1.2
   2026-09-11: badges say Water-Resistant + 30-Day Returns to match the refund policy.
   2026-09-12: labels the exit-popup email field for screen readers. */
(function () {
  'use strict';

  /* ── Trust badge injection on product pages ─────────────── */
  var BADGE_HTML = '<div class="mondsee-trust-badges">'
    + '<span class="mondsee-trust-badge">'
    + '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 1 3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4z" stroke="currentColor" fill="none" stroke-width="1.5" stroke-linejoin="round"/></svg>'
    + 'Water-Resistant</span>'
    + '<span class="mondsee-trust-badge">'
    + '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><polyline points="20 6 9 17 4 12" stroke="currentColor" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
    + 'Tarnish-Resistant</span>'
    + '<span class="mondsee-trust-badge">'
    + '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" stroke="currentColor" fill="none" stroke-width="1.5" stroke-linejoin="round"/></svg>'
    + '30-Day Returns</span>'
    + '<span class="mondsee-trust-badge">'
    + '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><rect x="1" y="4" width="22" height="16" rx="2" stroke="currentColor" fill="none" stroke-width="1.5"/><line x1="1" y1="10" x2="23" y2="10" stroke="currentColor" stroke-width="1.5"/></svg>'
    + 'Secure Checkout</span>'
    + '</div>';

  function injectBadges() {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    if (!forms.length) return;
    forms.forEach(function (form) {
      if (!form.parentNode.querySelector('.mondsee-trust-badges')) {
        form.insertAdjacentHTML('afterend', BADGE_HTML);
      }
    });
    // Fallback: after payment button
    if (!document.querySelector('.mondsee-trust-badges')) {
      var payBtn = document.querySelector('.shopify-payment-button');
      if (payBtn) payBtn.insertAdjacentHTML('afterend', BADGE_HTML);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectBadges);
  } else {
    injectBadges();
  }
  /* ── Accessibility: label the exit-popup email field ─────
     snippets/mondsee-extras.liquid renders the popup's email input with a
     placeholder only, which screen readers may not announce as a label.
     Adding it here avoids touching that file; if it is ever edited, put
     aria-label="Email address" on .mnd-popup__input and delete this block. */
  function labelPopupEmail() {
    document.querySelectorAll('.mnd-popup__input').forEach(function (input) {
      if (!input.getAttribute('aria-label')) {
        input.setAttribute('aria-label', 'Email address');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', labelPopupEmail);
  } else {
    labelPopupEmail();
  }
})();
